<template>
  <div class="flex flex-row overflow-y-scroll uploader-content-list mb-4">
    <ContentList :event-id="eventId" adminMode></ContentList>
  </div>
  <FormUpload :event-id="eventId"></FormUpload>
</template>

<script>
import ContentList from "./ContentList";
import FormUpload from "./FormUpload";

export default {
  props: {
    eventId: {
      type: Number,
      required: true,
    },
  },
  components: {
    ContentList,
    FormUpload,
  },
};
</script>

<style>
</style>